import { useState } from "react";
import axios from "../api/axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default function RoleAdd({ triggerReload }: { triggerReload: () => void }) {
    const [name, setName] = useState("");

    const handleSubmit = async () => {
        if (!name.trim()) return;

        try {
            await axios.post("/roles", { name });

            await MySwal.fire("Başarılı", "Rol başarıyla eklendi", "success");
            setName("");
            triggerReload();
        } catch (err: any) {
            console.error("Rol eklenemedi", err);
            await MySwal.fire("Hata", "Rol eklenirken sorun oluştu", "error");
        }
    };

    return (
        <div className="bg-white p-4 rounded shadow max-w-md">
            <h3 className="text-md font-semibold mb-2">ğŸ†• Yeni Rol Ekle</h3>
            <input
                className="border p-2 w-full mb-3"
                placeholder="Rol adı"
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <button
                onClick={handleSubmit}
                className="bg-blue-600 text-white px-4 py-2 rounded"
            >
                Ekle
            </button>
        </div>
    );
}
